export default __webpack_public_path__ + "static/media/tab4-image3.6fd39dc9.png";